import Entity from '../entity'

export default class ClaimAction extends Entity<number>{
    claim_id: number;
    user_id: number;
    action: string;
}
